import { render, staticRenderFns } from "./TaskTree.vue?vue&type=template&id=56932744&"
import script from "./TaskTree.vue?vue&type=script&lang=js&"
export * from "./TaskTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports